export default __webpack_public_path__ + "static/media/bars-icon.5d3867d2.svg";